"use client";

import * as React from 'react';
import Button from '../button';
const PickerButton = props => ( /*#__PURE__*/React.createElement(Button, Object.assign({
  size: "small",
  type: "primary"
}, props)));
export default PickerButton;